import React from 'react';
import { Sparkles } from 'lucide-react';

import { C, CT } from '../../constants/theme';
import { useTranslation } from '../../i18n/I18nProvider.jsx';
import { suggestedPrompts } from '../../screens/Chat/Chat.shared.js';

// The empty state of a new conversation. core.md §9.1.
//
// «دربارهٔ {name} بپرسید» and four cards BUILT FROM THE RECORD (§9.1): a case
// with a name and a chief complaint gets «{name} را خلاصه کن» and a differential
// for that complaint; a blank case gets the four static prompts. Clicking one
// SENDS it — and sends exactly the text it shows, so a student can learn what a
// good question to this assistant looks like by reading what they just pressed.
//
// Each of them costs ten پارسه like any other question; the price is on the
// composer directly below, where it is read before the click.

export default function SuggestedPrompts({ name, caseRecord = null, onPick }) {
  const { t } = useTranslation();
  const prompts = React.useMemo(
    () => suggestedPrompts(caseRecord).map((p) => ({ key: p.key, text: t(p.key, p.params) })),
    [caseRecord, t],
  );

  return (
    <div
      data-testid="chat-empty"
      style={{
        flex: 1, minHeight: 0, overflowY: 'auto',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        gap: 14, padding: '24px 16px', textAlign: 'center',
      }}
    >
      <Sparkles size={30} color={C.teal} aria-hidden strokeWidth={1.5} />
      <h2 style={{ margin: 0, fontSize: 19, fontWeight: 800, color: C.textPrimary }}>
        {t('chat.empty.title', { name })}
      </h2>
      <p style={{ margin: 0, fontSize: 13, color: CT.ink2, lineHeight: 1.9, maxWidth: 520 }}>
        {t('chat.empty.body')}
      </p>

      <div
        style={{
          display: 'grid', gap: 10, width: '100%', maxWidth: 640,
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          marginTop: 4,
        }}
      >
        {prompts.map(({ key, text }) => (
          <button
            key={key}
            type="button"
            onClick={() => onPick?.(text)}
            data-testid="suggested-prompt"
            style={{
              font: 'inherit', fontSize: 13, lineHeight: 1.8, cursor: 'pointer',
              textAlign: 'start', padding: '12px 14px',
              background: C.card, border: `1px solid ${C.border}`, borderRadius: 12,
              color: C.textPrimary,
            }}
          >
            {text}
          </button>
        ))}
      </div>
    </div>
  );
}
